(function () {
    if (!customElements.get("lsg-bundle")) {
        customElements.define("lsg-bundle", class LSGBundle extends HTMLElement {
            constructor() {
                super();
                this.selectors = {
                    atcButton: ".js-lsg-bundle-submit-button",
                    quantityInput: ".js-lsg-bundle-product-quantity-input",
                    faqButton: ".js-lsg-faq-button",
                    productsAdd: ".js-lsg-bundle-product-btn",
                    product: ".js-lsg-bundle-product",
                    quantityControlPlus: ".js-lsg-bundle-product-quantity-control-plus",
                    quantityControlMinus: ".js-lsg-bundle-product-quantity-control-minus",
                    productPrice: ".js-lsg-bundle-product-price",
                    resultProduct: ".js-lsg-bundle-result",
                    resultProductQuantity: ".js-lsg-bundle-result-quantity",
                    resultProductRemove: ".js-lsg-bundle-result-remove",
                    totalComparePrice: ".js-lsg-bundle-total-price-compare",
                    totalRegularPrice: ".js-lsg-bundle-total-price-regular",
                    discount: ".js-lsg-bundle-discount",
                    frequencySelect: ".lsg-bundle__frequency-select",
                    sellingPlanInput: 'input[name="selling_plan"]',
                    progressMin: ".js-lsg-bundle-progress-min",
                    progressSteps: ".js-lsg-bundle-progress-steps",
                    progressStep: ".js-lsg-bundle-discounts-step",
                    stickyBtnToggle: ".js-lsg-bundle-sticky-btn-toggle",
                    totalProducts: ".js-lsg-bundle-total-products",
                    collectionsFilter: ".js-lsg-bundle-collection-filter"
                };
                this.classes = {
                    isNotActive: "is-not-active",
                    isEmpty: "is-empty",
                    isActive: "is-active"
                }
                this.atcButton = this.querySelectorAll(this.selectors.atcButton);
                this.productsAdd = this.querySelectorAll(this.selectors.productsAdd);
                this.products = this.querySelectorAll(this.selectors.product);
                this.quantityControlPlus = this.querySelectorAll(this.selectors.quantityControlPlus);
                this.quantityControlMinus = this.querySelectorAll(this.selectors.quantityControlMinus);
                this.resultProductRemove = this.querySelectorAll(this.selectors.resultProductRemove);
                this.discount = this.querySelectorAll(this.selectors.discount);
                this.totalRegularPrice = this.querySelectorAll(this.selectors.totalRegularPrice);
                this.totalComparePrice = this.querySelectorAll(this.selectors.totalComparePrice);
                this.frequencySelect = this.querySelectorAll(this.selectors.frequencySelect);
                this.sellingPlanInput = this.querySelector(this.selectors.sellingPlanInput);
                this.progressMin = this.querySelectorAll(this.selectors.progressMin);
                this.progressSteps = this.querySelectorAll(this.selectors.progressSteps);
                this.stickyBtnToggle = this.querySelectorAll(this.selectors.stickyBtnToggle);
                this.totalProducts = this.querySelectorAll(this.selectors.totalProducts);
                this.collectionsFilter = this.querySelectorAll(this.selectors.collectionsFilter);


                this.totalQuantityMax = parseInt(this.getAttribute("data-max-quantity"));
                this.totalQuantityMin = parseInt(this.getAttribute("data-min-quantity"));
                this.dataDiscounts = JSON.parse(this.getAttribute("data-discounts"));

                this.currencyFormatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                });
                // this.faqButton = this.querySelectorAll(this.selectors.faqButton);
                // document.documentElement.style.setProperty("--main-backgceil-color", "green");
                this.init();
            }

            // updateInterval(trigger) {
            //     //updates bundle block classes, resets displayed prices, and sets the selling_plan input value
            //     const bundleBlock = getBundleBlock(trigger);
            //     const sellingPlanInput = bundleBlock.querySelector('.lsg-bundle-form input[name="selling_plan"]');
            //     const frequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
            //
            //     switch (trigger.value) {
            //         case 'otp':
            //             bundleBlock.classList.remove('lsg-bundle--sub-selected');
            //             bundleBlock.classList.add('lsg-bundle--otp-selected');
            //             sellingPlanInput.value = '';
            //             break;
            //         case 'sub':
            //             bundleBlock.classList.remove('lsg-bundle--otp-selected');
            //             bundleBlock.classList.add('lsg-bundle--sub-selected');
            //             sellingPlanInput.value = frequencySelect.value;
            //             break;
            //     }
            //
            //     this.updateBundlePrice(trigger);
            //     this.updateSellingPlan(trigger);
            // }

            // initializeBundle() {
            //     const rechargeBundles = this.querySelectorAll('[data-recharge-product-id]');
            //     console.log('1rechargeBundle!!!!!!', rechargeBundles);
            //     if (rechargeBundles) {
            //         Promise.all([...rechargeBundles].map(async rechargeBundle => {
            //             console.log('rechargeBundle!!!!!!');
            //
            //             // replace liquid defined data and attributes with info pulled from ReCharge SDK
            //             const rechargeBundleSettings = await recharge.cdn.getCDNBundleSettings(rechargeBundle.getAttribute('data-recharge-product-id'));
            //             console.log("rechargeBundleSettings", rechargeBundleSettings)
            //             const blocks = rechargeBundleSettings.variants;
            //             await Promise.all([...rechargeBundle.querySelectorAll('.lsg-bundle-block')].map(async (bundleBlock, blockIndex) => {
            //                 const blockSettings = blocks[blockIndex];
            //                 const blockMin = blockSettings.ranges[0].quantity_min;
            //                 const blockMax = blockSettings.ranges[0].quantity_max;
            //                 const blockSelectionOptions = blockSettings.option_sources;
            //                 // update block with CDN settings
            //                 bundleBlock.setAttribute('data-otp-bundle-min', blockMin);
            //                 bundleBlock.setAttribute('data-sub-bundle-min', blockMin);
            //                 bundleBlock.setAttribute('data-otp-bundle-max', blockMax);
            //                 bundleBlock.setAttribute('data-sub-bundle-max', blockMax);
            //                 const selectedProductsEls = bundleBlock.querySelectorAll('[data-bundle-builder-selected-products]');
            //                 selectedProductsEls.forEach((selectedProductsEl) => {
            //                     for (let index = 0; index < blockMax; index++) {
            //                         const selectedProductPlaceholder = `
            //                     <div class="bundle-builder__selected-product" data-bundle-builder-selected-product-id data-index="${index}">
            //                         <div class="bundle-builder__selected-product-img-wrapper">
            //                             <div class="bundle-builder__selected-product-placeholder" data-bundle-builder-selected-placeholder-placeholder>
            //                             </div>
            //                             <img src="" alt="" class="bundle-builder__selected-product-image" data-bundle-builder-selected-product-image>
            //                         </div>
            //                         <div class="bundle-builder__selected-product-title-wrap">
            //                             <span class="bundle-builder__selected-product-title" data-bundle-builder-selected-product-title></span>
            //                         </div>
            //                         <button class="bundle-builder__selected-product-remove-button lsg-bundle-product-select-quantity-minus" data-bundle-builder-selected-product-remove-button></button>
            //                     </div>
            //                 `;
            //                         selectedProductsEl.insertAdjacentHTML('beforeend', selectedProductPlaceholder);
            //                     }
            //                 });
            //                 await Promise.all(blockSelectionOptions.map(async blockSelectionOption => {
            //                     const optionCollection = window.collections_json?.find(collection => collection.id == blockSelectionOption.collection_id)?.handle;
            //                     if (optionCollection) {
            //                         const collectionRequest = await fetch(`/collections/${optionCollection}?view=bundle-ajax`);
            //                         const collectionText = await collectionRequest.text();
            //                         const collectionProducts = new DOMParser().parseFromString(collectionText, 'text/html').querySelector('#bundle_ajax_products').children;
            //                         const bundleBlockProductList = bundleBlock.querySelector('.lsg-bundle-product-list');
            //                         const collectionProductsWrapper = document.createElement('div');
            //                         collectionProductsWrapper.setAttribute('data-bundle-min', `${blockMin}`);
            //                         collectionProductsWrapper.setAttribute('data-bundle-max', `${blockMax}`);
            //                         collectionProductsWrapper.className = 'lsg-bundle-product-set-list lsg-bundle-product-sub-list';
            //                         collectionProductsWrapper.setAttribute('data-lsg-bundle-product-sub-list', ``);
            //                         collectionProductsWrapper.replaceChildren(...collectionProducts);
            //                         bundleBlockProductList.replaceChildren(collectionProductsWrapper);
            //                     }
            //                 }));
            //                 // updateProductProgress(bundleBlock);
            //             }));
            //         }));
            //     }
            //     //loop through bundle blocks
            //     // document.querySelectorAll('.lsg-bundle-block').forEach( (bundleBlock)=> {
            //     //     //set bundle block classes and initial selling_plan input
            //     //     const intervalSelect = bundleBlock.querySelector('.lsg-bundle-interval-select');
            //     //     const onlyOTP = bundleBlock.querySelector('.lsg-bundle-interval-only-otp');
            //     //     const onlySub = bundleBlock.querySelector('.lsg-bundle-interval-only-sub');
            //     //     const sellingPlanInput = bundleBlock.querySelector('.lsg-bundle-form input[name="selling_plan"]');
            //     //     const frequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
            //     //     if (intervalSelect) {
            //     //         //has otp/sub selector
            //     //         bundleBlock.classList.add('lsg-bundle--has-interval-select');
            //     //         let selectedInterval = intervalSelect.querySelector('input[name^="bundle_interval_select_"]:checked');
            //     //         switch (selectedInterval.value) {
            //     //             case 'otp':
            //     //                 bundleBlock.classList.add('lsg-bundle--otp-selected');
            //     //                 sellingPlanInput.value = '';
            //     //                 break;
            //     //             case 'sub':
            //     //                 bundleBlock.classList.add('lsg-bundle--sub-selected');
            //     //                 sellingPlanInput.value = frequencySelect.value;
            //     //                 break;
            //     //         }
            //     //         this.updateInterval(selectedInterval);
            //     //     } else if (onlyOTP) {
            //     //         //has only otp options
            //     //         bundleBlock.classList.add('lsg-bundle--only-otp');
            //     //         sellingPlanInput.value = '';
            //     //     } else if (onlySub) {
            //     //         //has only sub options
            //     //         bundleBlock.classList.add('lsg-bundle--only-sub');
            //     //         sellingPlanInput.value = frequencySelect.value;
            //     //     }
            //     //
            //     //     //intial enable/disable for quantity increments and submit button
            //     //     bundleBlock.querySelectorAll('.lsg-bundle-product-set-list').forEach(function (productSetList) {
            //     //         incrementEnableValidation(productSetList.querySelector('.lsg-bundle-product-select-quantity-input'));
            //     //     });
            //     //     checkoutEnableValidation(sellingPlanInput);
            //     //     setTimeout(function () {
            //     //         bundleBlock.classList.add('is-initialized');
            //     //     }, 500);
            //     //
            //     //     const disclaimerTriggers = bundleBlock.querySelectorAll('[rtx-value-prop-disclaimer-trigger]');
            //     //     disclaimerTriggers.forEach(trigger => {
            //     //         trigger.addEventListener('click', () => {
            //     //             const disclaimer = trigger.closest('[rtx-value-prop-disclaimer]');
            //     //             if (disclaimer) {
            //     //                 disclaimer.classList.add('active');
            //     //             }
            //     //         });
            //     //     });
            //     //     const disclaimerOverlays = bundleBlock.querySelectorAll('[rtx-value-prop-disclaimer-overlay]');
            //     //     disclaimerOverlays.forEach(overlay => {
            //     //         overlay.addEventListener('click', () => {
            //     //             const disclaimer = overlay.closest('[rtx-value-prop-disclaimer]');
            //     //             if (disclaimer) {
            //     //                 disclaimer.classList.remove('active');
            //     //             }
            //     //         });
            //     //     });
            //     // });
            // }

            getTotalQuantity() {
                let quantity = 0;
                Array.from(this.querySelectorAll(this.selectors.quantityInput)).forEach(ele => {
                    if (ele.value) {
                        quantity = quantity + parseInt(ele.value, 10)
                    }
                });
                return quantity;
            }

            updateQuantity(product, increase, newInputValue) {
                const quantityInput = product.querySelector(this.selectors.quantityInput);
                if (quantityInput != null) {
                    const value = parseInt(quantityInput.value, 10);
                    const max = parseInt(quantityInput.getAttribute("max"));
                    const min = parseInt(quantityInput.getAttribute("min"));
                    const totalQuantity = this.getTotalQuantity();

                    if (increase == true) {
                        const newValue = value + 1;
                        if (newValue <= max && totalQuantity <= this.totalQuantityMax) {
                            quantityInput.value = newValue;
                        }
                    } else {
                        const newValue = newInputValue != undefined ? newInputValue : value - 1;

                        if (newValue >= 0) {
                            quantityInput.value = newValue;
                        }
                    }
                    this.updateProducts();
                    this.updateATC();
                    this.setPrices();
                }
            }

            updateProductResult(product, quantity) {
                const productResultBlocks = this.querySelectorAll(`${this.selectors.resultProduct}[data-product="${product.getAttribute("data-product")}"]`);
                productResultBlocks.forEach(productResultBlock => {
                    const quantityResultBlock = productResultBlock.querySelector(this.selectors.resultProductQuantity);
                    if (quantity > 0) {
                        productResultBlock.classList.remove(this.classes.isEmpty);
                    } else {
                        productResultBlock.classList.add(this.classes.isEmpty);
                    }
                    if (quantityResultBlock) {
                        quantityResultBlock.innerHTML = quantity;
                    }
                });

            }

            removeProduct(el) {
                const product = this.querySelector(`${this.selectors.product}[data-product="${el.getAttribute("data-product")}"]`);
                this.updateQuantity(product, false, 0);
            }

            updateATC() {

                const totalQuantity = this.getTotalQuantity();
                if (totalQuantity >= this.totalQuantityMin) {
                    this.classList.add(this.classes.isActive);

                    this.atcButton.forEach(button => {
                        button.removeAttribute("disabled")
                    });
                } else {
                    this.classList.remove(this.classes.isActive);

                    this.atcButton.forEach(button => {
                        button.setAttribute("disabled", "disabled")
                    })
                }
                const diff = this.totalQuantityMin - totalQuantity;
                this.atcButton.forEach(button => {
                    if (diff <= 0) {
                        button.innerHTML = button.getAttribute("data-text")
                    } else {
                        if (diff == 1) {
                            button.innerHTML = button.getAttribute("data-text-one")
                        } else {
                            button.innerHTML = button.getAttribute("data-text-multiple")
                        }
                    }
                });
            }

            updateProducts() {
                this.products.forEach(product => {
                    const quantityInput = product.querySelector(this.selectors.quantityInput);
                    if (quantityInput != null) {
                        const value = parseInt(quantityInput.value, 10);
                        const totalQuantity = this.getTotalQuantity();
                        const quantityControlMinus = product.querySelector(this.selectors.quantityControlMinus);
                        const quantityControlPlus = product.querySelector(this.selectors.quantityControlPlus);
                        const productsAdd = product.querySelector(this.selectors.productsAdd);

                        const max = parseInt(quantityInput.getAttribute("max"));
                        const min = parseInt(quantityInput.getAttribute("min"));

                        if (value > 0) {
                            product.classList.remove(this.classes.isNotActive);
                        } else {
                            product.classList.add(this.classes.isNotActive);
                        }

                        if (value <= 0) {
                            quantityControlMinus?.setAttribute("disabled", "disabled");
                        } else {
                            quantityControlMinus?.removeAttribute("disabled");
                        }

                        if (totalQuantity == this.totalQuantityMax) {
                            quantityControlPlus?.setAttribute("disabled", "disabled");
                            productsAdd?.setAttribute("disabled", "disabled");
                        } else {
                            productsAdd?.removeAttribute("disabled");
                            if (max == value) {
                                quantityControlPlus?.setAttribute("disabled", "disabled");
                            } else {
                                quantityControlPlus?.removeAttribute("disabled");
                            }
                        }
                        this.updateProductResult(product, value);
                    }
                });
                this.limitResultSlots(this.querySelectorAll('.lsg-bundle__sticky .lsg-bundle__result'));
                this.limitResultSlots(this.querySelectorAll('.lsg-bundle__coll--sidebar .lsg-bundle__result'));
            }
            limitResultSlots(el) {
                const allResults = Array.from(el);

                const filledItems = allResults.filter(el => !el.classList.contains('is-empty'));
                const emptyItems = allResults.filter(el => el.classList.contains('is-empty'));
                allResults.forEach(el => el.style.display = 'none');

                let visibleCount = 0;

                filledItems.forEach(el => {
                        el.style.display = 'block';
                        visibleCount++;
                });

                emptyItems.forEach(el => {
                    if (visibleCount < 5) {
                        el.style.display = 'block';
                        visibleCount++;
                    }
                });
            }
            setDiscountProgress(discountObject, totalQuantity) {


                let percentage = totalQuantity / (this.totalQuantityMin - 1) * 100;

                this.progressMin.forEach(el => {
                    el.style.setProperty("--lsg-bundle-discounts-progress-bar", `${percentage > 100 ? 100 : percentage}%`);
                });
                const firstDiscount = this.dataDiscounts?.discounts[0];
                const length = this.dataDiscounts?.discounts.length;
                const lastDiscount = this.dataDiscounts?.discounts[length - 1];
                const minValue = firstDiscount.quantity;
                const maxValue = lastDiscount.quantity;

                const dif = maxValue - minValue + 1;
                percentage = (totalQuantity - minValue + 0.5) / dif * 100;
                if (totalQuantity < minValue) {
                    percentage = 0;
                }

                if (totalQuantity >= maxValue) {
                    percentage = 100;
                }
                this.progressSteps.forEach(el => {
                    el.style.setProperty("--lsg-bundle-discounts-progress-bar", `${percentage > 100 ? 100 : percentage}%`);
                });


                const step = this.querySelectorAll(`${this.selectors.progressStep}`);
                step.forEach(item => {
                    if (totalQuantity >= parseInt(item.getAttribute("data-quantity"), 10)) {
                        item.classList.add(this.classes.isActive);
                    } else {
                        item.classList.remove(this.classes.isActive);
                    }
                })

            }

            setPrices() {
                const totalQuantity = this.getTotalQuantity();
                let discountObjects = this.dataDiscounts?.discounts.filter(item => item.quantity <= totalQuantity);
                let discountObject = discountObjects[discountObjects.length - 1];
                if (discountObjects.length == 0) {
                    discountObject = this.dataDiscounts?.discounts[0];
                }
                let totalPrice = 0;
                let totalPriceWithDiscount = 0;

                this.products.forEach(product => {
                    const productPriceWrap = product.querySelector(this.selectors.productPrice);
                    const quantityInput = product.querySelector(this.selectors.quantityInput);

                    const quantity = parseInt(quantityInput.value, 10);
                    if (productPriceWrap != null && quantityInput != null) {

                        const originPrice = parseInt(productPriceWrap.getAttribute("data-price"), 10);

                        const priceHTML = productPriceWrap.getAttribute("data-price");

                        const spgJSON = JSON.parse(quantityInput.getAttribute('data-spgs'))[0];
                        let price = originPrice;
                        let newPrice = price;
                        if (spgJSON) {
                            const bundleSellingPlan = this.querySelector('input[name="selling_plan"]').value;
                            const selectedSellingPlanOption = this.querySelector(`${this.selectors.frequencySelect} option[value="${bundleSellingPlan}"]`);

                            const sellingPlan = spgJSON.selling_plans.find(selling_plan => {
                                return JSON.stringify(selling_plan.options) == selectedSellingPlanOption.getAttribute('data-selling-plan-options');
                            });
                            if (sellingPlan) {
                                if (sellingPlan.checkout_charge?.value_type == "percentage") {
                                    price = sellingPlan.checkout_charge?.value / 100 * originPrice;
                                }
                                if (discountObject != undefined) {
                                    newPrice = price - (price / 100 * discountObject.discount);
                                }
                            }
                            if (price > newPrice) {
                                productPriceWrap.innerHTML = `<s>${this.currencyFormatter.format(price / 100)}</s> ${this.currencyFormatter.format(newPrice / 100)}`;
                                if (quantity > 0) {
                                    totalPrice += price * quantity;
                                    totalPriceWithDiscount += newPrice * quantity;
                                }
                            } else {
                                productPriceWrap.innerHTML = this.currencyFormatter.format(price / 100);

                                totalPrice += price * quantity;
                            }
                        }
                        this.discount.forEach(el => {

                            if (discountObject != undefined) {
                                el.innerHTML = `${discountObject.discount}% OFF`;
                            } else {
                                el.innerHTML = "";
                            }

                        });
                        this.totalRegularPrice.forEach(el => {
                            if (totalPriceWithDiscount < totalPrice) {
                                if (discountObject != undefined) {
                                    el.innerHTML = this.currencyFormatter.format(Math.ceil(totalPrice - (totalPrice / 100 * discountObject.discount)) / 100);
                                }
                            } else {
                                el.innerHTML = this.currencyFormatter.format(Math.ceil(totalPrice) / 100);
                            }
                        });

                        this.totalComparePrice.forEach(el => {
                            if (totalPriceWithDiscount < totalPrice) {
                                el.innerHTML = this.currencyFormatter.format(Math.ceil(totalPrice) / 100);
                            } else {
                                el.innerHTML = "";
                            }
                        });

                    }

                })
                this.totalProducts.forEach(el => {
                    el.innerHTML = `(${totalQuantity} Bottles)`
                });
                this.setDiscountProgress(discountObject, totalQuantity);
            }

            init() {
                this.setPrices();
                this.stickyBtnToggle.forEach(el => {
                    el.addEventListener("click", () => {
                        this.classList.toggle("is-sticky-open");
                        document.querySelector("body").classList.toggle("is-sticky-open");
                    })
                })

                this.atcButton.forEach(el => {
                    el.addEventListener("click", (e) => {
                        e.preventDefault();

                        const bundleBlock = this;
                        const bundleSellingPlan = this.sellingPlanInput.value;
                        let interval = (bundleSellingPlan == '' ? 'otp' : 'sub');
                        const bundleMin = (interval == 'otp' ? bundleBlock.dataset.otpBundleMin : bundleBlock.dataset.subBundleMin);
                        const bundleMax = (interval == 'otp' ? bundleBlock.dataset.otpBundleMax : bundleBlock.dataset.subBundleMax);

                        interval = 'sub';
                        const bundleProductListInputs = this.querySelectorAll(this.selectors.quantityInput);


                        const isRechargeBundle = true;

                        const rechargeProductID = this.getAttribute('data-recharge-product-id');
                        const rechargeVariantID = this.getAttribute('data-recharge-variant-id');
                        const rechargeProductHandle = this.getAttribute('data-recharge-product-handle');
                        const rechargeBundleParentId = this.getAttribute('data-recharge-bundle-parent-id');

                        let rechargeBundleObj = {};
                        let rechargeSelections = [];
                        if (isRechargeBundle) {
                            rechargeBundleObj.externalProductId = rechargeProductID;
                            rechargeBundleObj.externalVariantId = rechargeVariantID;
                        }

                        let bundleProductQuantity = 0;


                        bundleProductListInputs.forEach((bundleProductInput) => {
                            bundleProductQuantity = bundleProductQuantity + parseInt(bundleProductInput.value);
                            if (parseInt(bundleProductInput.value) > 0) {


                                if (isRechargeBundle) {
                                    const rechargeCollectionID = "262223331412";
                                    const externalProductID = bundleProductInput.getAttribute('data-external-product-id');
                                    const rechargeSelectionItem = {
                                        collectionId: rechargeCollectionID,
                                        externalProductId: externalProductID,
                                        externalVariantId: bundleProductInput.getAttribute('data-product'),
                                        quantity: parseInt(bundleProductInput.value)
                                    }
                                    if (interval == 'sub') {
                                        const spgJSON = JSON.parse(bundleProductInput.getAttribute('data-spgs'))[0];
                                        if (spgJSON) {
                                            const selectedSellingPlanOption = bundleBlock.querySelector(`${this.selectors.frequencySelect} option[value="${bundleSellingPlan}"]`);
                                            if (selectedSellingPlanOption) {
                                                const sellingPlan = spgJSON.selling_plans.find(selling_plan => {
                                                    return JSON.stringify(selling_plan.options) == selectedSellingPlanOption.getAttribute('data-selling-plan-options');
                                                });
                                                if (sellingPlan) {
                                                    rechargeSelectionItem['sellingPlan'] = parseInt(sellingPlan.id);
                                                }
                                            }
                                        }
                                    }
                                    rechargeSelections.push(rechargeSelectionItem);
                                }
                            }
                        });
                        if (bundleProductQuantity > bundleMax || bundleProductQuantity < bundleMin) {
                            //quantity is not within bundle size
                            return false;
                        }


                        if (isRechargeBundle) {
                            rechargeBundleObj.selections = rechargeSelections;
                            const rechargeBundleIsValid = recharge.bundle.validateDynamicBundle(rechargeBundleObj)
                            if (rechargeBundleIsValid === true) {
                                const rechargePayload = recharge.bundle.getDynamicBundleItems(rechargeBundleObj, rechargeProductHandle);
                                if (rechargeBundleParentId) {
                                    const UUID = rechargePayload[0].properties._rc_bundle;
                                    if (UUID) {
                                        rechargePayload.push({
                                            id: rechargeBundleParentId,
                                            properties: {
                                                _rc_pseudo_bundle: UUID,
                                            },
                                            quantity: 1,
                                        });
                                    }
                                }
                                const rechargeCartData = {items: rechargePayload};
                                console.log(rechargeCartData);
                                fetch('/cart/add.js', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Requested-With': 'XMLHttpRequest',
                                    },
                                    body: JSON.stringify(rechargeCartData),
                                    credentials: 'same-origin'
                                }).then(response => {
                                    if (response.status == 200) {
                                        window.location.href = "/cart";
                                        console.error("added to cart");
                                    }
                                }).catch(error => {
                                    console.error(error);
                                });
                            } else {
                                console.log('recharge bundle settings invalid', rechargeBundleIsValid);
                            }
                        }
                    })
                });
                this.frequencySelect.forEach(el => {
                    el.addEventListener("change", () => {
                        this.sellingPlanInput.value = el.value;
                    });
                    this.frequencySelect.forEach(item => {
                        item.value = el.value;
                    });
                })
                this.productsAdd.forEach(el => {
                    el.addEventListener("click", () => {
                        this.updateQuantity(el.closest(this.selectors.product), true, undefined);
                    });
                });

                this.quantityControlPlus.forEach(el => {
                    el.addEventListener("click", () => {
                        this.updateQuantity(el.closest(this.selectors.product), true, undefined);
                    });
                });
                this.quantityControlMinus.forEach(el => {
                    el.addEventListener("click", () => {
                        this.updateQuantity(el.closest(this.selectors.product), false, undefined);
                    });
                });

                this.resultProductRemove.forEach(el => {
                    el.addEventListener("click", () => {
                        this.removeProduct(el);
                    });
                });

                const bottomObserver = new IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {
                        this.classList.remove('is-sticky-show');
                    } else {
                        this.classList.add('is-sticky-show');
                    }
                }, {
                    threshold: 1
                });
                bottomObserver.observe(this.querySelector('.lsg-bundle-atc-wrapper form'));
                this.collectionsFilter.forEach(el => {
                    el.addEventListener("click", () => {
                        this.collectionsFilter.forEach(item => {
                            item.classList.remove('is-active');
                        });
                        el.classList.add('is-active');
                        const id = el.getAttribute('data-collection');
                        if (id === "") {
                            this.products.forEach(product => {
                                product.classList.remove('is-hidden');
                            });
                        } else {
                            this.products.forEach(product => {
                                const collections = product.getAttribute('data-collections')?.split(',') || [];

                                if (collections.includes(id)) {
                                    product.classList.remove('is-hidden');
                                } else {
                                    product.classList.add('is-hidden');
                                }
                            });
                        }
                    })
                })
            }

            getGuid() {
                let d = new Date().getTime();
                let d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                    let r = Math.random() * 16;
                    if (d > 0) {
                        r = (d + r) % 16 | 0;
                        d = Math.floor(d / 16);
                    } else {
                        r = (d2 + r) % 16 | 0;
                        d2 = Math.floor(d2 / 16);
                    }
                    return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
                });
            }
        })

    }
})();